import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './LegislationDateSelectorsContainer';
import { searchConstants } from '../../../../search-utils/searchConstants';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { CommonSection } from '../../CommonSection';
import { withUser } from '../../../../../user/UserContext';
import { DaySelector } from '../DaySelector';
import { UserContextType } from '../../../../../user/user.types';
import { Checkbox } from '../../../../../components/checkbox/Checkbox';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

type State = {
  isSelected: boolean | undefined;
};

export class RawLegislationDateSelectors extends React.Component<Props, State> {
  state: State = {
    isSelected: !!this.props.selectedValue,
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.selectedValue !== this.props.selectedValue) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isSelected: !!this.props.selectedValue,
      });
    }
  }

  toggleDate = () => {
    const {
      accessPremium,
      openRestrictedModal,
      onDatesUpdate,
      selectedValue,
    } = this.props;
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
      return;
    }

    doctrineAnalytics('Search DateSelectorClicked', {
      search_type: 'law',
    });

    this.setState(state => ({
      isSelected: !state.isSelected,
    }));

    if (this.state.isSelected && !!selectedValue) onDatesUpdate({});
  };

  render() {
    const {
      accessPremium,
      openRestrictedModal,
      onDatesUpdate,
      selectedValue,
    } = this.props;
    const { isSelected } = this.state;

    return (
      <CommonSection title={searchConstants.filters.inForceDates}>
        <div className="search_facet__wrapper">
          <button
            className="search-filters-checkbox"
            type="button"
            onClick={this.toggleDate}
          >
            <div className="search-filters-checkbox__wrapper">
              <span className="search-filters-checkbox__icon">
                <Checkbox checked={isSelected} />
              </span>
              <span className="search-filters-checkbox__label">
                <FormattedMessage id="search/components/aside-filters/dates/legislation/LegislationDateSelectors.tsx/1" />
              </span>
            </div>
          </button>
          {isSelected && (
            <DaySelector
              accessPremium={accessPremium}
              openRestrictedModal={openRestrictedModal}
              onDatesUpdate={onDatesUpdate}
              selectedValue={selectedValue}
              type="law"
              formatDate={(date: string) => ({
                exact: date,
              })}
            />
          )}
        </div>
      </CommonSection>
    );
  }
}

export const LegislationDateSelectors = withRestrictedModal(
  withUser(Connect(RawLegislationDateSelectors)),
);
